<div class="login-button login-button__primary" [class.login-button--disabled]="disabled">
    <div class="login-button-content">
        <ng-content></ng-content>
    </div>
</div>
